import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { deleteBookmarkAsync } from '../../../../redux/bookmark/Actions';

import { withStyles } from '@material-ui/core/styles';
import {
    Modal,
    Typography,
    Checkbox,
    FormControlLabel,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import { ViewFlagHover } from '../../Icons';
import DialogButton from '../../../Common/UI/Dialog/DialogButton';

class RemoveView extends React.Component {
    constructor(props) {
        super(props);

        this.removeBookmark = this.removeBookmark.bind(this);
    }

    removeBookmark() {
        const { bookmark, dispatchDeleteBookmark, onClose } = this.props;

        dispatchDeleteBookmark(bookmark.id);
        onClose();
    }

    render() {
        const { classes, open, onClose, bookmark } = this.props;

        return (
            <Dialog open={open} onClose={onClose} fullWidth>
                <DialogTitle disableTypography>
                    <DeleteIcon className={`${classes.silver}`} />
                    <Typography variant="h4">Remove View</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography color="textPrimary" variant="body2">
                        Are you sure you want to forget '{bookmark && bookmark.name}'
                        and all associated map layers?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        variant="contained"
                        className={classes.deleteButton}
                        onClick={this.removeBookmark}>
                        Remove
                    </DialogButton>
                    <DialogButton variant="outlined" onClick={onClose}>
                        Cancel
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    silver: {
        color: theme.palette.secondary.light
    },
    deleteButton: {
        background: theme.palette.error.main,
        color: theme.palette.text.dark
    }
});

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    dispatchDeleteBookmark: id => dispatch(deleteBookmarkAsync(id))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(RemoveView);
